import { Card } from "../../../components/ui/card";

export const DoctorCardSkeleton = () => {
  return (
    <Card className="relative overflow-hidden border-border bg-card">
      <div className="flex items-stretch gap-4 p-3">
        <div className="skeleton-block sk-delay-1 h-24 w-24 shrink-0 rounded-lg" />

        <div className="flex-1 space-y-3">
          <div className="skeleton-block sk-delay-2 h-5 w-3/4 rounded" />

          <div className="flex items-center gap-2">
            <div className="skeleton-block sk-delay-3 h-4 w-20 rounded" />
            <div className="skeleton-block sk-delay-4 h-4 w-32 rounded" />
          </div>

          <div className="flex items-center gap-2">
            <div className="skeleton-block sk-delay-5 h-4 w-20 rounded" />
            <div className="skeleton-block sk-delay-6 h-4 w-32 rounded" />
          </div>

          <div className="flex items-center gap-2">
            <div className="skeleton-block sk-delay-7 h-4 w-20 rounded" />
            <div className="skeleton-block sk-delay-8 h-6 w-16 rounded" />
          </div>
        </div>
      </div>

      <div className="mt-2 flex gap-3 border-t border-gray-300 p-3">
        <div className="skeleton-block sk-delay-9 h-10 w-28 rounded-md" />
        <div className="skeleton-block sk-delay-10 h-10 flex-1 rounded-md" />
      </div>
    </Card>
  );
};